<template>
  <div class="container_noData" :style="{ backgroundColor: background }">
    <img
      style="width: 120px; height: 88px"
      src="../../assets/images/default/pic-Search failed@2x.png"
      alt=""
    />
    <h1>暂时还没有相关数据~</h1>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: String,
      default: "#f2f2f2",
    },
  },
};
</script>

<style lang="less" scoped>
.container_noData {
  padding: 43px 400px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  h1 {
    width: 300px;
    text-align: center;
    margin-top: 20px;
    color: #989898;
    font-size: 14px;
  }
}
</style>